import { useNavigate } from 'react-router-dom';
import TopBar from '../components/molecules/TopBar';
import TopBarHomeButton from '../components/atoms/TopBarHomeButton';
import { useAppSelector } from '../store/hooks';
import timeIcon from '../static/icons/icon_time.svg';
import contactIcon from '../static/icons/icon_contact.svg'; 
import infoIcon from '../static/icons/icon_info.svg'; 
import questionMarkIcon from '../static/icons/icon_question_mark.svg'; 

const Settings = () => {
    const navigate = useNavigate();

    const showDevSettings = useAppSelector(state => state.globalState.user?.userProperties || []).includes('HAS_DEVSETTINGS');

    return (
        <div className="content">
            <TopBar
                title="Einstellungen"
                icon={'icon_settings.svg'}
                leftButtons={[<TopBarHomeButton />]}
            />
            <div className="content-container">
                <ul className="settings-list">
                    {showDevSettings && <li>
                        <div className="settings-category" onClick={() => navigate('dev-settings')}>
                            <div className="category-icon">
                                <img src={timeIcon} />
                            </div>
                            <div className="category-info">
                                <span className="category-name">Dev-Settings</span><br />
                            </div>

                            <div className="category-action">
                                <button className="action-button" />
                            </div>
                        </div>
                    </li>}
                    <li>
                        <div className="settings-category" onClick={() => navigate('contact')}>
                            <div className="category-icon">
                                <img src={contactIcon} />
                            </div>
                            <div className="category-info">
                                <span className="category-name">Kontakt / Fragen</span><br />
                            </div>

                            <div className="category-action">
                                <button className="action-button" />
                            </div>
                        </div>
                    </li>
                    <li>
                        <div className="settings-category" onClick={() => navigate('about')}>
                            <div className="category-icon">
                                <img src={infoIcon} />
                            </div>
                            <div className="category-info">
                                <span className="category-name">Impressum</span><br />
                            </div>

                            <div className="category-action">
                                <button className="action-button" />
                            </div>
                        </div>
                    </li>
                    <li>
                        <div className="settings-category" onClick={() => navigate('privacy')}>
                            <div className="category-icon">
                                <img src={questionMarkIcon} />
                            </div>
                            <div className="category-info">
                                <span className="category-name">Datenschutz</span><br />
                            </div>

                            <div className="category-action">
                                <button className="action-button" />
                            </div>
                        </div>
                    </li>
                </ul>
            </div>
        </div>
    );
};

export default Settings;